import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static values = {
    listId: String,
    submitForm: Boolean,
    updateMethod: { type: String, default: "GET" },
    updatePath: String,
  };

  connect() {
    this.pendingUploadsCount = 0;
  }

  upload() {
    const files = Array.from(this.element.files || []);
    if (files.length === 0) return;

    if (this.pendingUploadsCount === 0) {
      this.dispatch("start");
    }

    this.pendingUploadsCount += files.length;

    if (this.submitFormValue) {
      this.submitButton?.setAttribute("disabled", true);
    }

    Promise.all(
      files.map((file) =>
        this.uploadFile(file).catch((error) => {
          console.error(error);
        }),
      ),
    ).finally(() => {
      this.element.value = "";
      this.pendingUploadsCount -= files.length;

      if (this.pendingUploadsCount === 0) {
        this.dispatch("stop");
      }
    });
  }

  uploadFile(file) {
    const upload = new DirectUpload(
      file,
      "/rails/active_storage/direct_uploads",
      this.element,
    );

    return new Promise((resolve, reject) => {
      upload.create((error, blob) => {
        if (error) {
          reject(error);
        } else if (this.submitFormValue) {
          this.submitBlob(blob);
          resolve(blob);
        } else {
          this.updateFilesList(blob).then(resolve).catch(reject);
        }
      });
    });
  }

  submitBlob(blob) {
    const input = document.createElement("input");

    input.name = "blob_signed_id";
    input.value = blob.signed_id;
    input.hidden = true;

    this.form.append(input);
    this.form.requestSubmit();
  }

  updateFilesList(blob) {
    let path = this.hasUpdatePathValue
      ? this.updatePathValue
      : `/file_attachments/${blob.signed_id}`;

    if (this.hasListIdValue) {
      path += `?${new URLSearchParams({ list_id: this.listIdValue })}`;
    }

    const options = {
      method: this.updateMethodValue,
      credentials: "same-origin",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    };

    if (this.updateMethodValue !== "GET") {
      options.headers["Content-Type"] = "application/json";
      options.headers["X-CSRF-Token"] = document.querySelector(
        'meta[name="csrf-token"]',
      ).content;
      options.body = JSON.stringify({
        blob_signed_id: blob.signed_id,
        list_id: this.listIdValue,
      });
    }

    return fetch(path, options)
      .then((response) => response.text())
      .then((html) => {
        window.Turbo.renderStreamMessage(html);
      });
  }

  get form() {
    return this.element.closest("form");
  }

  get submitButton() {
    return this.form?.querySelector("button");
  }
}
